<template>
  <div class="learning-component-container pt-10">
    <a-row :gutter="32">
      <a-col :span="24">
        <div class="mb-30">
          <p class="font-web mb-10 text-dark font-weight-bold">
            รายละเอียด / Description
          </p>
          <p class="font-web mb-20 text-muted">
            Information and documents regarding Career Growth.
          </p>
        </div>

        <a-spin :spinning="loadingProfile">
          <!-- 1. Academic Promotion, Tracks for full-time academic staff -->
          <div v-if="isAcademicStaff" class="section-block mb-30">
            <h3 class="section-title">Academic Promotion, Tracks</h3>
            <div class="mt-15">
              <table class="doc-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th class="text-center">File</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(doc, idx) in academicStaticDocs" :key="idx">
                    <td>
                      <div class="file-name-main">{{ doc.name }}</div>
                      <div v-if="doc.videoLink" class="file-video-link">
                        <a :href="doc.videoLink" target="_blank" rel="noopener noreferrer" class="video-link">
                          <a-icon type="video-camera" /> Video Link
                        </a>
                      </div>
                    </td>
                    <td class="text-center">
                      <a :href="doc.link" target="_blank" rel="noopener noreferrer" class="download-link">
                        <a-icon type="file-pdf" />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 2. Career Advancement, Tracks for full-time supporting staff -->
          <div v-if="isSupportingStaff" class="section-block mb-30">
            <h3 class="section-title">Career Advancement, Tracks</h3>
            <div v-if="careerDocs.length > 0" class="mt-15">
              <table class="doc-table">
                <thead>
                  <tr>
                    <th>รายการไฟล์ / File List</th>
                    <th class="text-center">Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(doc, idx) in careerDocs" :key="idx">
                    <td>
                      <div class="file-name-main">{{ doc.name }}</div>
                      <div v-if="doc.updatedAt" class="file-date">อัปเดตเมื่อ: {{ formatDate(doc.updatedAt) }}</div>
                    </td>
                    <td class="text-center">
                      <a v-if="doc.link && doc.link !== '#'" :href="doc.link" target="_blank" rel="noopener noreferrer" class="download-link">
                        <a-icon type="download" />
                      </a>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-muted mt-10 italic">ไม่พบข้อมูล / No data found</div>
          </div>

          <!-- Fallback when user is neither full-time academic staff nor full-time supporting staff -->
          <div v-if="!loadingProfile && !isAcademicStaff && !isSupportingStaff" class="section-block mb-30">
            <div class="text-muted italic">ไม่พบข้อมูลที่ตรงกับประเภทบุคลากรของคุณ / No data available for your staff
              category.</div>
          </div>
        </a-spin>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({ docs: [] })
    },
    contractNameEng: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userContractNameEng: this.contractNameEng || '',
      loadingProfile: false,
      academicStaticDocs: [
        {
          name: 'Part 1 MU Central Regulation and Promotion Criteria.pdf',
          link: 'https://drive.google.com/file/d/15xf5NeKHXX02LJQq2o4Y6vo5nqyHO0fR/view?usp=drive_link',
          videoLink: 'https://drive.google.com/file/d/12uLb_ZbQvviJ5yDtxhXQdamll38MWXdx/view?usp=drive_link'
        },
        {
          name: 'Part 2 MUIC_Internal Guideline.pdf',
          link: 'https://drive.google.com/file/d/14iC-jwo_GLZVtlzpvhhk_TnO2OJ_71P8/view?usp=drive_link',
          videoLink: 'https://drive.google.com/file/d/1XxtOAd9agM8H9ENndVjuBRWTPMS_uDK3/view?usp=drive_link'
        },
        {
          name: 'Part 3 Research ethics for MUIC trainning.pdf',
          link: 'https://drive.google.com/file/d/1aoMCi7zwgc1iy9YvxPNExok-9EXyx4Mq/view?usp=drive_link',
          videoLink: 'https://drive.google.com/file/d/1-ra3FjzCdwOQBDvTnxGeo1ruEBkQOzMV/view?usp=drive_link'
        },
        {
          name: 'Part 4 Building Portfolio of Academic Promotion.pdf',
          link: 'https://drive.google.com/file/d/1XGOEnMeFzKy9w6dTo6efvL62LK0JnbSN/view?usp=drive_link'
        }
      ]
    };
  },
  computed: {
    effectiveContractName() {
      return (this.contractNameEng || this.userContractNameEng || '').trim().toLowerCase();
    },
    isAcademicStaff() {
      return this.effectiveContractName === 'full-time academic staff';
    },
    isSupportingStaff() {
      return this.effectiveContractName === 'full-time supporting staff';
    },
    academicDocs() {
      if (!this.item || !this.item.docs) return [];
      return this.item.docs.filter(doc => doc.name && (doc.name.toLowerCase().includes('academic') || doc.name.includes('วิชาการ')));
    },
    careerDocs() {
      if (!this.item || !this.item.docs) return [];
      return this.item.docs.filter(doc => doc.name && (doc.name.toLowerCase().includes('career') || doc.name.toLowerCase().includes('advancement') || doc.name.includes('สายสนับสนุน') || doc.name.includes('สายปฏิบัติงาน')));
    }
  },
  watch: {
    contractNameEng(newVal) {
      if (newVal) {
        this.userContractNameEng = newVal;
      }
    }
  },
  mounted() {
    if (!this.contractNameEng && !this.userContractNameEng) {
      this.fetchUserProfile();
    }
  },
  methods: {
    async fetchUserProfile() {
      this.loadingProfile = true;
      try {
        const res = await this.$http.get('/staff/profile/me/');
        if (res.status === 200 && res.data && res.data.contract) {
          this.userContractNameEng = res.data.contract.name_eng || '';
        }
      } catch (error) {
        console.error('Error fetching base profile in CareerGrowth:', error);
      } finally {
        this.loadingProfile = false;
      }
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 8px;
}

.section-block {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.text-muted {
  color: #8c8c8c;
}

.text-dark {
  color: #1a1a2e;
}

.font-weight-bold {
  font-weight: 600;
}

.italic {
  font-style: italic;
}

/* Document Table Styles */
.doc-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.doc-table th {
  background: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 700;
  color: #1a1a2e;
  border-bottom: 2px solid #e8e8e8;
  font-size: 14px;
}

.doc-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  color: #434343;
  font-size: 14px;
}

.file-name-main {
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.4;
}

.file-date {
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 4px;
}

.file-video-link {
  margin-top: 6px;
}

.video-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #1890ff;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.video-link:hover {
  color: #096dd9;
  text-decoration: underline;
}

.text-center {
  text-align: center !important;
}

.download-link {
  color: #4285F4;
  font-size: 18px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.download-link:hover {
  color: #1a73e8;
  transform: translateY(-2px);
}

.mt-15 {
  margin-top: 15px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-30 {
  margin-bottom: 30px;
}

.pt-10 {
  padding-top: 10px;
}
</style>
